/**
 * Zentrale Salon-/Kalkulations-Währungsformatierung.
 * Billing/Stripe/Admin bleiben separat strikt EUR — hier nur Mandanten-Kalkulation.
 */

export type AppCurrencyCode = 'EUR' | 'CHF';

/** Normalisiert Rohwerte (€, Fr., country.currency) auf ISO-Kürzel. */
export const resolveCurrencyCode = (
    raw?: string | null,
    activeLand?: string | null
): AppCurrencyCode => {
    const land = String(activeLand || '').trim().toUpperCase();
    if (land === 'CH') return 'CHF';
    const c = String(raw || '').trim().toUpperCase();
    if (c === 'CHF' || c === 'FR.' || c === 'FR' || c === 'SFR') return 'CHF';
    return 'EUR';
};

/**
 * formatMoney(15.24, 'EUR') → "15,24 EUR"
 * formatMoney(15.24, 'CHF') → "15,24 CHF"
 */
export const formatMoney = (
    amount: number,
    currencyCode: string = 'EUR',
    decimals: number = 2
): string => {
    const code = resolveCurrencyCode(currencyCode);
    const n = Number.isFinite(amount) ? amount : 0;
    const digits = Number.isFinite(decimals) && decimals >= 0 ? Math.floor(decimals) : 2;
    const formatted = new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
    }).format(n);
    return `${formatted} ${code}`;
};

/** Kurzes Suffix für Input-Felder (ohne Betrag). */
export const currencyLabel = (
    raw?: string | null,
    activeLand?: string | null
): AppCurrencyCode => resolveCurrencyCode(raw, activeLand);
